/** @format */

import React, { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";
import SettingsIcon from "@mui/icons-material/Settings";
import PageviewIcon from "@mui/icons-material/Pageview";
import EditIcon from "@mui/icons-material/Edit";
import AppleIcon from "@mui/icons-material/Apple";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import PrintIcon from "@mui/icons-material/Print";
import TableRowsIcon from "@mui/icons-material/TableRows";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';

import { SYSTEM_PATH, SYSTEM_PATH_COMPANY } from "../App";
import { decrypt } from "../utils/crypto";
import { ScreenStatusContext } from "../context/ScreenStatusContext";
import { confirmWhenChanged } from "../utils/validation";
import SALES_RECORD_TYPE from "../utils/variable";
import DeveloperMenu from "./DevelopMenu";

// メニュー定義
let companyHeaderMenuContents = [
  {
    title: "日次入力",
    icon: LibraryBooksIcon,
    items: [
      {
        title: "地　販売原票",
        icon: BookmarkAddIcon,
        path: `/sales_record/register_entry/${SALES_RECORD_TYPE.LOCAL}`,
      },
      {
        title: "旅　販売原票",
        icon: BookmarkAddIcon,
        path: `/sales_record/register_entry/${SALES_RECORD_TYPE.TRAVEL}`,
      },
      {
        title: "在　販売原票",
        icon: BookmarkAddIcon,
        path: `/sales_record/register_entry/${SALES_RECORD_TYPE.STOCK}`,
      },
      {
        title: "原票一括入力",
        icon: BookmarkAddIcon,
        path: "/sales_record/collective_entry"
      },
      {
        title: "チェーンストア",
        icon: BookmarkAddIcon,
        path: "/entry/chain_store",
      },
      {
        title: "コンテナ",
        icon: InputIcon,
        path: "/sales_record/container_return_entry",
      },
      {
        title: "入金管理",
        icon: InputIcon,
        path: "/sales_record/receipt_entry",
      },
      {
        title: "出金管理",
        icon: InputIcon,
        path: "/sales_record/payment_entry",
      },
    ],
    isOpen: false,
  },
  {
    title: "日次/月次出力",
    icon: OutputIcon,
    isOpen: false,
    items: [
      {
        title: "帳票印刷",
        icon: PrintIcon,
        path: "/print/print_manage",
      },
      {
        title: "売掛金日計表",
        icon: PageviewIcon,
        path: "/account_receivable_balance",
      },
      {
        title: "売掛金残高一覧",
        icon: PageviewIcon,
        path: "/account_receivable_balance_monthly",
      },
      {
        title: "買掛金日計表",
        icon: PageviewIcon,
        path: "/account_payable_confirmation",
      },
      {
        title: "買掛金残高一覧",
        icon: PageviewIcon,
        path: "/account_payable_confirmation_monthly",
      },
      {
        title: "売上報告書",
        icon: PageviewIcon,
        path: "/sales_record/report_confirmation",
      },
      {
        title: "請求一覧表",
        icon: PageviewIcon,
        path: "/billing_confirmation",
      },
      {
        title: "振込一覧表",
        icon: PageviewIcon,
        path: "/transfer_confirmation",
      },
      {
        title: "担当者在庫一覧",
        icon: PageviewIcon,
        path: "/staff_stock",
      },
      {
        title: "仕入売上振替",
        icon: PageviewIcon,
        path: "/sales_purchase_transfer",
      },
    ],
  },
  {
    title: "基本価格表",
    icon: BusinessIcon,
    items: [
      { title: "基本価格表 表示", icon: PageviewIcon, path: "/basic_price" },
      { title: "基本価格表 編集", icon: EditIcon, path: "/basic_price_edit" },
    ],
    isOpen: false,
  },
  {
    title: "市況価格表",
    icon: StoreIcon,
    items: [
      { title: "注文票確認", icon: PageviewIcon, path: "/order_form_confirm" },
    ],
    isOpen: false,
  },
  {
    title:"受注",
    icon: ContentPasteGoIcon,
    items: [
      {title: "注文入力(単入力)", icon: PageviewIcon, path: "/simple_order_entry"},
      {title: "CSV注文", icon: PageviewIcon, path: "/csv_import_order"},
      {title: "注文集約", icon: PageviewIcon, path: "/order_summary"}
    ],
    isOpen: false
  },
  {
    title:"発注",
    icon: LocalShippingIcon,
    items: [
      {title: "発注入力・確認", icon: PageviewIcon, path: "/supply_list"}
    ],
    isOpen: false
  },
  {
    title: "管理",
    icon: SettingsIcon,
    items: [
      { title: "取引先", icon: StoreIcon, path: "/customer_search" },
      /*       {title: "取引先送信グループ管理", icon: StoreIcon, path: "/customer_send_group_list"}, */
      /*       {title: "新規取引先送信グループ作成", icon: StoreIcon, path: "/customer_send_group_registration"}, */
      /*       {title: "仕入先検索", icon: StoreIcon, path: "/supplier_search"}, */
      /*       {title: "新規仕入先登録", icon: StoreIcon, path: "/supplier_registration"},    */
      { title: "商品", icon: AppleIcon, path: "/product_master" },
      {
        title: "営業カレンダー",
        icon: CalendarViewMonthIcon,
        path: "/market_calendar",
      },
      { title: "変数", icon: TableRowsIcon, path: "/var" },
      { title: "買人", icon: TableRowsIcon, path: "/buyer" },
      { title: "荷主", icon: TableRowsIcon, path: "/commodity_owner" },
    ],
    isOpen: false,
  },
  /* {
    title: "請求テンプレート",
    icon: SettingsIcon,
    isOpen: false,
    items: [
      { title: "配達メモ", icon: AppleIcon, path: "/delivery_note" },
      { title: "配送ガイド", icon: AppleIcon, path: "/delivery_guide" },
      { title: "請求書", icon: AppleIcon, path: "/billing_statement" },
    ],
  }, */
];

/**
 * サイドメニューコンポーネント
 */
export function Sidemenu(props) {
  const navigate = useNavigate();
  const [menus, setMenus] = React.useState(companyHeaderMenuContents);

  // 画面ステータスをcontextから取得
  const { isChanged } = useContext(ScreenStatusContext);

  // サイドメニュークリック時に実行する外部ハンドラーをセット
  const menuCloseHandler = props.menuCloseHandler;

  /**
   * メニュー開閉処理
   */
  const MenuOpenClose = (targetIndex) => {
    setMenus((prevMenus) =>
      prevMenus.map((menu, index) =>
        index === targetIndex
          ? {
              title: menu.title,
              icon: menu.icon,
              items: menu.items,
              isOpen: !menu.isOpen,
            }
          : menu
      )
    );
  };

  /**
   * メニュー選択処理
   */
  const SelectMenu = (path) => {
    // 画面ステータスで変更ありの場合、確認モーダル表示
    if (confirmWhenChanged(isChanged)) {
      // メニューに対応した画面に遷移
      navigate(SYSTEM_PATH_COMPANY + path);
      // サイドメニューを閉じる
      menuCloseHandler();
    }
  };

  /**
   * ログアウト処理
   */
  const SignOut = () => {
    // トークンの削除
    sessionStorage.removeItem("token");
    // 利用者情報の削除
    sessionStorage.removeItem("userInfo");
    // ログイン画面に戻る
    navigate(SYSTEM_PATH);
  };

  return (
    // 複数のエレメントを返すのでReact.Flagment（<></>）で囲む
    <>
      {decrypt(sessionStorage.userInfo).userTypeCd === 1 && (
        <>
          <List>
            <ListItemButton
              component="button"
              onClick={() => navigate(SYSTEM_PATH_COMPANY + "/home")}
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="ホーム" />
            </ListItemButton>
          </List>
          <Divider />
          <List>
            {companyHeaderMenuContents.map((menuContents, index) => (
              <List key={menuContents?.title + index}>
                <ListItemButton onClick={() => MenuOpenClose(index)}>
                  <ListItemIcon>
                    <menuContents.icon />
                  </ListItemIcon>
                  <ListItemText primary={menuContents.title} />
                  {menus[index].isOpen ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </ListItemButton>
                <Collapse in={menus[index].isOpen} timeout="auto" unmountOnExit>
                  <List>
                    {menuContents.items.map((menuItems, i) => (
                      <ListItemButton
                        key={i + 1}
                        component="button"
                        onClick={() => SelectMenu(menuItems.path)}
                        sx={{ pl: 4, width: "100%" }}
                      >
                        <ListItemIcon>
                          <menuItems.icon />
                        </ListItemIcon>
                        <ListItemText primary={menuItems.title} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </List>
            ))}
          </List>
        </>
      )}
      <Divider />
      <List>
        {["ログアウト"].map((text, index) => (
          <ListItemButton key={index + 1} component="button" onClick={SignOut}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItemButton>
        ))}
      </List>
      <DeveloperMenu SelectMenu={SelectMenu}/>
    </>
  );
}
